import { ShoppingCart, PackagePlus } from "lucide-react";
import { toast } from "sonner";
import { useStore } from "@/lib/store";
import { DeliveryBadge, inr } from "@/components/badges";
import { SaveListButton } from "@/components/SaveListButton";

export const ToolResultList = ({ items, total, testid, source = "cart" }) => {
  const { addToCart } = useStore();
  const valid = items.filter((i) => i.product);

  const addAll = () => {
    if (!valid.length) return;
    const vendor = valid[0].product.vendor_id;
    const same = valid.filter((i) => i.product.vendor_id === vendor);
    same.forEach((i) => addToCart(i.product, i.qty));
    if (same.length < valid.length) toast.info(`${valid.length - same.length} item(s) from other vendors skipped — single-vendor cart.`);
  };

  return (
    <div data-testid={testid} className="space-y-3">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-slate-600">{valid.length} catalog matches · est. <span className="font-bold text-slate-900">{inr(total)}</span> excl. GST</p>
        <button onClick={addAll} data-testid={`${testid}-add-all`} className="btn-brand !py-2 text-xs"><PackagePlus className="h-3.5 w-3.5" /> Add all to cart</button>
        <SaveListButton items={valid.map((i) => ({ product_id: i.product.id, qty: i.qty }))} source={source} testid={`${testid}-save`} />
      </div>
      <div className="divide-y divide-slate-200 card-surface">
        {items.map((it, idx) => (
          <div key={idx} className="p-3 flex items-center gap-3" data-testid={`${testid}-row-${idx}`}>
            {it.product ? (
              <>
                <img src={it.product.image} alt="" className="h-12 w-12 rounded-lg object-cover bg-slate-100 shrink-0" />
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-semibold text-slate-900 truncate">{it.product.name}</p>
                  <p className="text-xs text-slate-500 truncate">{it.label || it.reason || it.input} {it.basis ? `· ${it.basis}` : ""}</p>
                  <p className="text-xs text-slate-500 mt-0.5 flex items-center gap-2">{it.product.vendor_name} <DeliveryBadge mode={it.product.express_eligible ? "express" : "scheduled"} /></p>
                </div>
                <div className="text-right shrink-0">
                  <p className="text-sm font-bold text-slate-900">{it.qty} × {inr(it.product.price)}</p>
                  <p className="text-[11px] text-slate-500">/{it.product.unit}</p>
                </div>
                <button onClick={() => addToCart(it.product, it.qty)} data-testid={`${testid}-add-${idx}`} className="btn-dark !px-3 !py-2 text-xs shrink-0"><ShoppingCart className="h-3.5 w-3.5" /></button>
              </>
            ) : (
              <p className="text-sm text-slate-500">{it.label || it.input} — <span className="text-red-600">no catalog match</span></p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
